import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";

/**
 * 智能输入框控件
 */
export class InputGroupControl implements IControl {

    /**
     * 获取控件类型，返回值：智能输入框控件类型
     */
    getControlType(): ControlType {
        return ControlType.InputGroup;
    }
    isRequired(): boolean {
        return !!this.required;
    }

    /**
     * 是否允许输入
     */
    editable: boolean;

    /**
     * 按钮显示文本
     */
    groupText: string;

    /**
     * 使用模式（文本、弹出表单）
     */
    usageMode: string;

    /**
     * 弹出表单相关配置
     */
    dialogOptions: DialogConfig;

    /**
     * 按钮点击事件
     */
    click: any;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;
    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;
    /**
     * 默认显示
     */
    placeholder:string;
}

export class DialogConfig {
    modalId: string;
    mapFields: any;
    title: string;
    width: number;
    height: number;
    // showButtons: boolean;
    // buttons: DialogButtonConfig[];
}

export class DialogButtonConfig {
    text: string;
    cls: any;
    handle: any;
}